import React from "react"
import { Container, Row, Col } from "reactstrap"

import { PieChartComponent } from "../shared"

const SectionEducation = ({ county }) => {
  const higherRatings = ["A+", "A", "A-", "B+", "B", "B-"]
  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col md={4} xs={12}>
          <div className="d-flex flex-column justify-content-center align-items-start mt-5">
            <h5>Education Rate</h5>
            <h2>
              {county.rating.educated_rate
                ? Math.ceil(county.rating.educated_rate * 100)
                : 0}{" "}
              %
            </h2>
          </div>
        </Col>
        <Col md={8} xs={12}>
          <PieChartComponent zipRating={county.rating} />
        </Col>
      </Row>
    </Container>
  )
}

export default SectionEducation
